import React, { useEffect, useState } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import CAStore from "../../Store/TemplateStore/template.store";
import {
  cleanData,
  storePlantData,
  storeUserEmail,
  storePlantRowData,
} from "../../Store/TemplateStore/template.action";

import { getPlants, deletePlants } from "../../network/cipAPI";
import Header from "../../components/Header";
import AgTable from "../../components/AgTable";
import DupontDialog from "../../components/DupontDialog";
import DupontButton from "../../components/DupontButton";
import InputBox from "../../components/InputBox";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import PageLoading from "../../components/PageLoading";
import createNotification, {
  SUCCESS_NOTIFICATION,
  ERROR_NOTIFICATION,
} from "../../components/Notifications";

import { updatePlantId } from "../../utils/Utils";
import { saveItemSession } from "../../utils/session";
import ShareDialog from "../shareDialog";
import { PLANT_COL_DEF } from "./plantsTable.config";

import "./index.scss";
import { API_URLS } from "../../network/appUrls";

const basePath = API_URLS.basePath;

export const store = CAStore;

const PlantPage = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector((state) => state.token);
  const userEmail = useSelector((state) => state.userEmail);
  const plantColDef = PLANT_COL_DEF(t);
  const [loadHome, setloadHome] = useState(false);
  const [deletedRow, setDeletedRow] = useState(null);
  const [plantId, setPlantId] = useState(null);
  const [showDeletePopup, setShowDeletedDialog] = useState(false);
  const [isLoading, setisLoading] = useState(true);
  const [trainDialogOpen, setTrainDialogOpen] = useState(false);
  const [errors, setErrors] = useState();
  const [confirmDisabled, setConfirmDisabled] = useState(false);
  const [noOfTrains, setNoOfTrains] = useState(1);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const requestStatus = useSelector((state) => state.requestStatus);
  const plantRowData = useSelector((state) => state.plantRowData);
  useEffect(() => {
    updatePlantId();
    setloadHome(true);
    dispatch(cleanData());
  }, []);

  useEffect(() => {
    dispatch(storeUserEmail(userEmail));
  }, [userEmail]);

  useEffect(() => {
    if (errors) {
      setConfirmDisabled(true);
    } else {
      setConfirmDisabled(false);
    }
  }, [errors]);

  useEffect(() => {
    const getPlantDetails = async () => {
      try {
        const response = await getPlants();
        if (response && response.data) {
          dispatch(storePlantRowData(response.data));
          const plantsWithTrain = response.data.map((plant) => ({
            plant_id: plant.plant_id,
            sel_train: plant.sel_train,
          }));
          dispatch(storePlantData(plantsWithTrain));
          setisLoading(false);
        } else {
          dispatch(storePlantRowData([]));
        }
      } catch (err) {
      } finally {
        setisLoading(false);
      }
    };

    if (
      token &&
      (requestStatus === -1 ||
        requestStatus === 2 ||
        requestStatus === "-1" ||
        requestStatus === "2")
    ) {
      getPlantDetails();
    }
  }, [token, requestStatus]);

  const deleteHandler = async (params) => {
    setDeletedRow(params);
    setShowDeletedDialog(true);
  };

  const addNewPlant = () => {
    setNoOfTrains(1);
    setTrainDialogOpen(true);
  };

  const onConfirmClicked = () => {
    updatePlantId(0);
    const path = `${basePath}addPlant`;
    navigate(path, { state: { noOfTrains } });
  };

  const editHandler = (params) => {
    updatePlantId(params.plant_id);
    const path = `${basePath}editPlant?plantId=${
      params.plant_id
    }&isEdit=${true}`;
    navigate(path, { state: { noOfTrains: params.num_trains } });
  };
  const shareHandler = (params) => {
    updatePlantId(params.plant_id);
    setPlantId(params.plant_id);
    setShareDialogOpen(true);
  };

  const viewHandler = (params) => {
    updatePlantId(params.plant_id);
    const path = `${basePath}home?plantId=${params.plant_id}`;
    navigate(path, { state: { isEdit: true } });
  };

  const onProceedClicked = async (value) => {
    setShowDeletedDialog(false);
    if (value === "CONFIRM") {
      try {
        updatePlantId(deletedRow.plant_id);
        const data = await deletePlants();

        if (data && data.status === 200) {
          const newPlantRowList = plantRowData.filter(
            (item) => item.plant_id !== deletedRow.plant_id
          );
          dispatch(storePlantRowData(newPlantRowList));
          createNotification(
            SUCCESS_NOTIFICATION,
            t("notificationStrings.deleteSuccess"),
            ""
          );
        } else {
          createNotification(
            ERROR_NOTIFICATION,
            t("notificationStrings.deleteFail"),
            ""
          );
        }
      } catch (err) {}
    }
  };

  const navigateToAnalysisData = (data) => {
    updatePlantId(data.plant_id);
    const path = `${basePath}analyseData?plantId=${
      data.plant_id
    }&isEdit=${true}`;
    const plantPageURL = window.location.pathname + window.location.search;
    saveItemSession("water_type", data.water_type);
    saveItemSession("name", data.name);
    saveItemSession("plantPageURL", plantPageURL);
    navigate(path);
  };

  const handleClickOnPlantRow = (event) => {
    const clickedElement = event.event.target;
    if (clickedElement.closest(".custom-sharing-button")) {
      return;
    }

    const { data, node } = event;
    if (data.view === 1) editHandler(data);
    else if (data.view === 2) {
      navigateToAnalysisData(data);
    } else if (data.view === 3) {
      updatePlantId(data.plant_id);
      const path = `${basePath}home?plantId=${data.plant_id}`;
      navigate(path);
    }
  };
  const handleInputChange = (value) => {
    setNoOfTrains(value);
    let errorMessage = null;
    if (value === " " || value > 20 || value < 1) {
      errorMessage = `${t("roAdvisorProject.errorMesage")} `;
    }
    setErrors(errorMessage);
  };

  const onClose = (action) => {
    if (action === "CONFIRM") {
      onConfirmClicked();
    } else if (action === "CANCEL") {
      setTrainDialogOpen(false);
      setNoOfTrains(1);
      setErrors(null);
    }
  };
  return (
    <Provider store={store}>
      {loadHome && (
        <>
          <div className="container-main">
            <Header />
            <div className="main-container descriptionText">
              <div className="heading-text ">
                {t("roAdvisorProject.roAdvisor")}
              </div>
              <div className="marginBtm20">
                <DupontButton
                  onClick={addNewPlant}
                  customClass="margin-left-10 float-right  "
                  disabled={isLoading}
                >
                  {t("roAdvisorProject.addPlant")}
                </DupontButton>
                {trainDialogOpen && (
                  <DupontDialog
                    open={trainDialogOpen}
                    title={t("roAdvisorProject.trainDialogTitle")}
                    cancelBtnText={t("ValueStrings.cancel")}
                    confirmBtnText={t("ValueStrings.enter")}
                    confirmDisabled={confirmDisabled}
                    onClose={onClose}
                    minWidth={575}
                  >
                    <div className="flex-between-center">
                      <label className="font-14 descriptionText">
                        {t("roAdvisorProject.trainDialogText")}
                      </label>
                      <div className="dropdown-width marginBtm10">
                        <InputBox
                          value={noOfTrains}
                          validator={TextFieldValidator.NUMBER_ONLY}
                          maxLength={2}
                          onChange={(value) => handleInputChange(value)}
                          errorMsg={errors}
                        />
                      </div>
                    </div>
                    {noOfTrains > 1 && noOfTrains <= 20 && (
                      <div className="noteText">
                        {t("roAdvisorProject.noteMessage").replace(
                          "<value>",
                          noOfTrains
                        )}
                      </div>
                    )}
                  </DupontDialog>
                )}
              </div>
              <div className="margin-top-50">
                {isLoading ? (
                  <PageLoading customHeight={"420px"} />
                ) : (
                  plantRowData && (
                    <div className="margin-top-50">
                      <AgTable
                        columnDefs={plantColDef}
                        rowData={plantRowData}
                        hideExport
                        name={`${t("excelSheetNames.plants")}`}
                        context={{
                          deleteHandler,
                          editHandler,
                          shareHandler,
                          userEmail,
                        }}
                        onRowClicked={handleClickOnPlantRow}
                      />
                      {showDeletePopup && (
                        <DupontDialog
                          open={showDeletePopup}
                          type="primary"
                          title={t(
                            "notificationStrings.deleteConfirmationProject"
                          )}
                          cancelBtnText={t("ValueStrings.no")}
                          confirmBtnText={t("ValueStrings.yes")}
                          onClose={onProceedClicked}
                        />
                      )}
                      {shareDialogOpen && (
                        <ShareDialog
                          setShareDialogOpen={setShareDialogOpen}
                          shareDialogOpen={shareDialogOpen}
                          plantId={plantId}
                        />
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
            {/* {istermsDialogOpen && (
              <TermsConditions
                istermsDialogOpen={istermsDialogOpen}
                handleTermsDialogClose={handleTermsDialogClose}
              />
            )} */}
          </div>
        </>
      )}
    </Provider>
  );
};

export default PlantPage;
